import { Component, Input, ChangeDetectorRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { FormHelperService } from '../../../services/form-helper.service';
import notify from 'devextreme/ui/notify';
import { DropdownService } from '../../../services/dropdown-service';
import { RichFormComponent } from '../../../components/library/rich-form/rich-form.component';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrl: './company-details.component.scss'
})
export class CompanyDetailsComponent {
  entityTypes!: Array<string>;
  @Input() currencies!: Array<string>;
  @Input() formGroupName!: string; 
  @Output() isDataChanged = false;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();
  
  
  companyDetails!: FormGroup;
  isContentScrolled = false;
  oldCompanyData!: Record<string, any>;
  companyData!: Record<string, any>;
  isLoading = true;
  message = "Loading...";
  formUiWidgets!: Record<string, any>[] ; //= this.getBasicInfoItems();
  
  @ViewChild('companyFormComponent') companyFormComponent!: RichFormComponent;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private _formHelper: FormHelperService,
    private ref: ChangeDetectorRef,
    private _DropdownService : DropdownService) 
    {

    }

  //#region  Material Form
  ngOnInit(): void {

    this._DropdownService
    .GetMerchantCategories()
    .subscribe(resp=>
      { 
        this.entityTypes = resp.map(function(v){
          return v.name;
        }).sort((a, b) => {
          return a.localeCompare(b)
        });
        this.companyDetails = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
        this.formUiWidgets = this.getFormControls();
        this.isLoading = false;
      });
  }

  get formHelper() {
    return this._formHelper;
  }

  //#region DevExtreme Phasing in
  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }

  getFormControls(){
    return [
      {
        label: 'Entity Type',
        dataField: 'entitytype',
        editorType: 'dxSelectBox',
        colSpan: 1,
        colSize:2,
        width: '150px',
        editorOptions: {
          items: this.entityTypes,
          searchEnabled: true,
        },
        validators: [
          { type: 'required' }
        ],
        FormType : 'CompanyDetails'
      },
      { label: 'Company Name',
        dataField: 'companyName',
        colSpan: 1, 
        width: '150px',
        FormType: 'CompanyDetails',
        validators: [
          { type: 'required' }
        ],
      },
      { 
        label: 'Company Registration Number',
        dataField: 'registrationNumber', 
        colSpan: 1,
        width: '150px',
        validators: [
          { type: 'required' }
        ],
        FormType : 'CompanyDetails',
        
      },
      { 
        label: 'Sacrra Number',
        dataField: 'saccraMemberNumber', 
        colSpan: 1 , 
        width: '150px',
        FormType : 'CompanyDetails',
        
      },
      { 
        label: 'NCR Registration Number',
        dataField: 'ncrRegistrationNumber', 
        colSpan: 1,
        width: '150px',
        validators: [
          { type: 'required' }
        ],
        FormType : 'CompanyDetails'
      },
      { 
        label: 'Phoenix Id',
        dataField: 'phoenixId', 
        colSpan: 1,
        width: '150px',
        FormType: 'CompanyDetails',
        validators: [
          { type: 'required' }
        ],
        editorOptions: {
          maskInvalidMessage: 'Input does not conform to the required format.',
          valueChangeEvent: 'keyup',
          mask: 'HHHHHHHH-HHHH-HHHH-HHHH-HHHHHHHHHHHH',
          maskChar: '',
          maskRules : {
            // a regular expression
            H: /[0-9a-fA-F]/,
          }
          
        }
      }, 
    ]
  }


  dataChanged(object) {
    
    //set populated form field
    
    if ('event' in object) {

      if (typeof object.event.value === 'string' || object.event.value instanceof String) {

        let formValue: String = object.event.value;
        formValue = formValue.trim();
        if (object.event.dataField == "phoenixId")
        {
          formValue = formValue.replace(/\s+/g, '');  // Removes all whitespace (spaces, tabs, newlines)
        }
        

        this.companyDetails.patchValue({
          [object.event.dataField]: formValue
        });
      }
      else {
        this.companyDetails.patchValue({
          [object.event.dataField]: object.event.value
        });
      }
      
    }
    this.notifyContainerDataChanged.emit(object);
    
  }

  merchantCreateUpdate(event: any) {

    if('showLoadPanel' in event && 'message' in event){
      this.isLoading = event.showLoadPanel;
      this.message = event.message;
    }
  }

  checkFormValidity() {
    const invalidControls : any = [];
    Object.keys(this.companyDetails.controls).forEach(key => {
      const control = this.companyDetails.get(key);
      
      if (control?.invalid) {
        invalidControls.push({ field: key, errors: control?.errors });
      }
    });
    return invalidControls;
  }


  cancel() {
    this.companyData = this.oldCompanyData,
    this.companyFormComponent.clearForm();
  }
  //#endregion
}
